import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { ReviewApprovals } from "@/features/reviews/components/review-approvals"
import { ReviewChanges } from "@/features/reviews/components/review-changes"
import { ReviewEmails } from "@/features/reviews/components/review-emails"
import { ReviewActions } from "@/features/reviews/components/review-actions"
import { ReviewFilings } from "@/features/reviews/components/review-filings"
import { ReviewNotices } from "@/features/reviews/components/review-notices"
import { ReviewOverview } from "@/features/reviews/components/review-overview"
import { ReviewSteps } from "@/features/reviews/components/review-steps"
import { ReviewSummary } from "@/features/reviews/components/review-summary"
import { reviewQueries } from "@/queries/reviews"

/**
 * The review's first page: Merrin AI's overview, what the approver must
 * know, what changed, who has approved, then the AI's findings and the
 * emails it sent. A person's review lists its parts down the side, each
 * its own page; a firm's lists its steps here.
 */
export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/"
)({
  component: ReviewOverviewPage,
})

function ReviewOverviewPage() {
  const { reviewId } = Route.useParams()
  const { data: review } = useSuspenseQuery(reviewQueries.detail(reviewId))

  return (
    <>
      <PageHeader
        title="Overview"
        actions={<ReviewActions review={review} />}
      />
      <PageContent>
        <ReviewOverview review={review} />
        <ReviewNotices review={review} />
        {review.parts.length === 0 ? <ReviewSteps review={review} /> : null}
        <ReviewChanges review={review} />
        <ReviewApprovals review={review} />
        <ReviewFilings review={review} />
        <ReviewSummary review={review} />
        <ReviewEmails review={review} />
      </PageContent>
    </>
  )
}
